import ReactGA from 'react-ga';

const googleAnalyticsID: string = 'UA-113782372-2';

ReactGA.initialize(googleAnalyticsID, {debug: false});

export const logPageView = (path: string): void => {
	ReactGA.pageview(path);
};

/*
- Category: A top level category for these events. E.g. 'User', 'Navigation', 'App Editing', etc.
- Action: A description of the behaviour. E.g. 'Clicked Delete', 'Added a component', 'Deleted account', etc.
- Label: More precise labelling of the related action. E.g. alongside the 'Added a component' action,
we could add the name of a component as the label. E.g. 'Survey', 'Heading', 'Button', etc.
*/
export const logEvent = (category: string, action: string, label: string = null): void => {
	ReactGA.event({
		action,
		category,
		label: label || '',
	});
};
